import type { ReactNode } from 'react';

/**
 * A short figure or fact in a pill (DS `.badge`): "+1", "1 échec", "100 %",
 * "Message envoyé". Statuses use `StatusBadge`; this is for everything else.
 * Red only for something to fix (GLOSSARY-FR §2), and never colour alone.
 */
export type BadgeTone = 'ok' | 'err' | 'warn' | 'pri' | 'neutral' | 'outline';

const TONES: Record<BadgeTone, string> = {
  ok: 'bg-success-50 text-success-700',
  err: 'bg-danger-50 text-danger-700',
  warn: 'bg-warning-50 text-warning-700',
  pri: 'bg-primary-50 text-primary-700',
  neutral: 'bg-surface-3 text-ink-2',
  /** How an automation was built, "Rapide" / "Personnalisée" (DS `.b-outline`, R04): a fact, not a state. */
  outline: 'bg-transparent text-ink-2 ring-1 ring-inset ring-border-strong',
};

export function Badge({ tone = 'neutral', className = '', children }: { tone?: BadgeTone; className?: string; children: ReactNode }) {
  return (
    <span
      className={`tabular inline-flex h-[22px] shrink-0 items-center gap-[5px] whitespace-nowrap rounded-full px-2 text-ds-xs font-semibold ${TONES[tone]} ${className}`}
    >
      {children}
    </span>
  );
}
